/* React hooks */
import {useEffect, useRef} from "react";
/* Contexts */
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
/* API */
import {getBillingBySearch} from "../../../api/admin/billingReq";
import {getBillingAgencyList} from "../../../api/admin/agencyReq";
/* Components */
import BillingDetails from "../../../pages/admin/facturation/BillingDetails";
import DateInput from "../../../components/common/input-layout/DateInput";


export default function FormBillingSearch({setShowModalSearchBilling}) {

    const { auth } = useAuth();
    const token = auth?.token;
    const { billingAgencyList, setBillingAgencyList,
        billingSearchList, setBillingSearchList
    } = useData();
    const billingAgencyRef = useRef();
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    const startDateRef = useRef();
    const endDateRef = useRef();

    const apiBillingAgencyList = async () => {
        const response = await getBillingAgencyList(token);
        setBillingAgencyList(response);
    }

    const apiBillingSearch = async () => {
        let body = {
            billingAgencyId: billingAgencyRef?.current.value,
            startDate: startDateRef?.current.value,
            endDate: endDateRef?.current.value,
        }
        const response = await getBillingBySearch(token, body);
        setBillingSearchList(response);

    }

    useEffect(() => {
        apiBillingAgencyList();
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault()
        apiBillingSearch();
    }

    const handleRemoveModal = () => {
        setShowModalSearchBilling(false);
    };

    return (
        <fieldset className="column">
            <legend>Recherche de facturation</legend>
            <div className="form-input">
                <label>Agence de facturation</label>
                <select ref={billingAgencyRef} name="agency_list" onChange={handleSubmit}>
                    <option value="0">Sélectionnez une agence de facturation</option>
                    { billingAgencyList.map((agency) => (
                        <option key={agency?.id} value={agency?.id}>{agency?.name} ({agency?.zipcode} {agency?.city})</option>
                    ))}
                </select>
            </div>
            <div className="form-input">
                <label>Date de début</label>
                <DateInput ref={startDateRef} max="9999-12-31" name="startDate" onChange={handleSubmit} />
            </div>
            <div className="form-input">
                <label>Date de fin</label>
                <DateInput ref={endDateRef} max="9999-12-31" name="endDate" defaultValue={formattedDate} onChange={handleSubmit} />
            </div>
            <div className="facturation-div">
                { billingSearchList?.length > 0 &&
                    <BillingDetails location="Recherche de facturation" />
                }
            </div>
            <div className="buttons-container">
                <button type="button" className="red-button" onClick={handleRemoveModal}>
                    <i className="fa fa-xmark"></i>
                    <span>Fermer</span>
                </button>
            </div>
        </fieldset>
    );
}